import { CanAccess } from "ra-core";
import { DashboardActivityLog } from "./DashboardActivityLog";
import { DashboardToday } from "./DashboardToday";
import { WorkspaceWidget } from "./WorkspaceWidget";
export const Dashboard = () => (
  <div className="mt-2 grid items-start gap-5 lg:grid-cols-[minmax(220px,.8fr)_minmax(0,1.7fr)] xl:grid-cols-[minmax(220px,.8fr)_minmax(0,1.6fr)_minmax(250px,1fr)]">
    <div className="min-w-0">
      <WorkspaceWidget />
    </div>
    <div className="min-w-0">
      <CanAccess resource="activity_log" action="list">
        <DashboardActivityLog />
      </CanAccess>
    </div>
    <div className="min-w-0 lg:col-span-2 xl:col-span-1">
      <CanAccess resource="tasks" action="list">
        <DashboardToday />
      </CanAccess>
    </div>
  </div>
);
